import mutations from './mutation_types.js';

export default {
    [mutations.SET_MODAL_GENERATE_BALANCE_DATA](state, data) {
        state.modalGenerateBalanceData = data;
    },
    [mutations.SET_MODAL_GENERATE_BALANCE_ERRORS](state, errors) {
        state.errors = errors
    }
}